export default {
  id: 'teams_promote_internal_jobs',
  title: 'Promote internal jobs',
  type: 'Direct / Channel',
  canSendToChannel: true,
  relations: [ 'MANY_JOBS' ],
  description: 'Send up to 4 selected jobs to your employees so they can easily apply or share them with their collegues.',
  body: {
    attachments: [],
    body: {
      contentType: 'html',
      content: `
      <div>
        <p>[[INPUT_INTRODUCTION_TEXT]]</p>
        <BLOCK_JOB>
      </div>`.split('\n').map(line => line.trim().replaceAll('\n', '')).join(''),
    },
  },
  blocks: {
    BLOCK_JOB: id => `<attachment id='${id}'></attachment>`,
  },
  attachment: id => ({
    id,
    contentType: 'application/vnd.microsoft.card.adaptive',
    name: null,
    thumbnailUrl: null,
    contentUrl: null,
    content: JSON.stringify({
      type: 'AdaptiveCard',
      $schema: 'http://adaptivecards.io/schemas/adaptive-card.json',
      version: '1.4',
      body: [
        {
          type: 'ColumnSet',
          columns: [
            {
              type: 'Column',
              width: 1,
              items: [
                {
                  type: 'TextBlock',
                  text: '{{JOB_[ID]_TITLE}}',
                  wrap: true,
                  fontType: 'Default',
                  size: 'Large',
                  weight: 'Bolder'
                }
              ]
            }
          ]
        }
      ],
      actions: [
        {
          type: 'Action.OpenUrl',
          url: '{{JOB_[ID]_SHARE_LINK}}',
          title: 'Apply Now'
        },
        {
          type: 'Action.OpenUrl',
          url: '{{JOB_[ID]_COPY_SHARE_LINK}}',
          title: 'Copy Link'
        },
      ]
    })
  }),
  inputs: {
    INPUT_INTRODUCTION_TEXT: {
      label: 'Intro',
      placeholder: 'Apply to one of the following jobs or share that with your collegues to win some rewards! ...',
      defaultValue: 'Apply to one of the following jobs or share that with your collegues to win some rewards!',
      type: 'HTML'
    }
  }
};


// WEBPACK FOOTER //
// ./src/views/campaign-admin/templates/teams/promoteInternalJobs.js